import InputGroupsContainer from "../../Componant/FormControl/InputGroups";

const InputGroups = () => {
  return (
    <div className="page-body">
      <InputGroupsContainer />
    </div>
  );
};

export default InputGroups;
